<template>
  <!-- S : footer -->
  <div
    id="footer"
    class="a-service-footer"
    :class="floatingButtons ? 'fixed-btn-on' : ''"
  >
    <footer>
      <div class="footer footer_renewal">
        <div class="footer-cont-box">
          <div class="footer-cont0">
            <!--
  <ul class="footer-nav">
    <li><a href="/compliance/terms-of-use" title="이용약관">이용약관</a></li>
    <li><a href="https://www.amway.co.kr/compliance/info-policy" title="개인정보처리방침">개인정보처리방침</a></li>
    <li><a href="/compliance/security-guide" title="컴플라이언스 센터">컴플라이언스 센터</a></li>
    <li><a href="https://113366.com/" target="_blank" title="원격지원">원격지원</a></li>
    <li><a href="/sitemap" title="사이트맵">사이트맵</a></li>
    <li><a href="/notifications/notice?searchText=평균후원수당&amp;searchNoticeType=BUSINESS" title="평균 후원수당 공지">평균 후원수당 공지</a></li>
    <li><a href="#" onclick="ACC.common.openBusinessOwnerConfirmPopup(); return false; " title="사업자등록 여부 확인">사업자등록 여부 확인</a></li>
            </ul>
            -->

            <!-- S : 20230714 하이브리스 footer 와 동일하게 현행화 -->
            <p class="txt0">고객센터 (주문 및 제품, 사업 상담/정수기, 공기청정기 설치 및 수리)</p>
            <div class="footer-service-contact">
              <dl>
                <dt>전화</dt>
                <dd><a href="tel:1588-0080">1588-0080</a></dd>
              </dl>
              <dl>
                <dt>FAX</dt>
                <dd>02-557-2566</dd>
              </dl>
              <!-- <a href="mailto:cskorea@amway.com" target="_blank" title="새창 열림">이메일문의</a> -->
              <a href="https://www.amway.co.kr/customer/cs/emailqna/list" target="_self" title="이메일 문의">이메일 문의(cskorea@amway.com)</a>
            </div>
            <!-- E : 20230714 하이브리스 footer 와 동일하게 현행화 -->
            <button @click="toggleBusinessInfo" type="button" class="btn-foot_info" :class="classFooterInfoBtnActive">한국암웨이(주) 사업자 정보</button>
          </div>
          <div class="footer-cont1">
            <div class="txt-cont" :class="classFooterInfoVisible" id="footerInfo">
              <!-- S : 20230714 하이브리스 footer 와 동일하게 현행화 -->
              <address>한국암웨이(주) 서울특별시 강남구 영동대로 517 27층 (삼성동, 아셈타워) (대표이사 : 신은자, 존패트릭파커)<span class="txt_address"> 사업자 등록번호 : 120-81-03391 ㆍ 통신판매신고번호 : 제 강남-1179호</span></address>
              <p class="txt1">호스팅제공자 : 한국암웨이(주)
                <!-- <a href="http://www.ftc.go.kr/www/bizCommView.do?key=232&amp;apv_perm_no=2000322008330201179&amp;pageUnit=10&amp;searchCnd=bup_nm&amp;searchKrwd=%EC%95%94%EC%9B%A8%EC%9D%B4&amp;pageIndex=2" target="_blank" title="새창 열림">사업자정보공개페이지</a> -->
                <a href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1208103391" onclick="window.open(this.href, '_blank', 'width=750,height=700,toolbars=no,scrollbars=no'); return false;">사업자정보공개페이지</a>
              </p>
              <div class="certification">
                <!-- <a href=""> <img src="../../static/images/m_footer_hidden_info_logo_01.png" class="mo_img" alt="암인터넷사이트 안전마크"> <img src="../../static/images/w_footer_hidden_info_logo_01.png" class="pc_img" alt="암인터넷사이트 안전마크"> <span>인터넷사이트<br>안전마크</span> </a> -->
                <a href="https://www.kca.go.kr/ccm/certSystemOutlineView.do" target="_blank"> <img src="../../static/images/m_footer_hidden_info_logo_10.png" class="mo_img" alt="소비자중심 경영인증"> <img src="../../static/images/w_footer_hidden_info_logo_10.png" class="pc_img" alt="소비자중심 경영인증"> <span>소비자중심<br>경영인증</span> </a>
                <a href="https://www.amway.co.kr/compliance/certification-activity" target="_blank"> <img src="../../static/images/m_footer_hidden_info_logo_09.png" class="mo_img" alt="개인정보 보호마크"> <img src="../../static/images/w_footer_hidden_info_logo_09.png" class="pc_img" alt="개인정보 보호마크"> <span>개인정보<br>보호마크</span> </a>
                <a href="https://www.amway.co.kr/compliance/certification-activity" target="_blank"> <img src="../../static/images/m_footer_hidden_info_logo_03_v2.png" class="mo_img" alt="ISO/IEC 27001"> <img src="../../static/images/w_footer_hidden_info_logo_03.png" class="pc_img" alt="ISO/IEC 27001"> <span>ISO/IEC<br>27001</span> </a>
                <a href="https://www.amway.co.kr/compliance/certification-activity" target="_blank"> <img src="../../static/images/m_footer_hidden_info_logo_04_v2.png" class="mo_img" alt="정보보호 관리체계"> <img src="../../static/images/w_footer_hidden_info_logo_04.png" class="pc_img" alt="정보보호 관리체계"> <span>정보보호<br>관리체계</span> </a>
                <!-- <a href="https://www.macco.or.kr/ko/cn/KOCNMC01.action" target="_blank" title="새창열림"> <img src="../../static/images/m_footer_hidden_info_logo_05.png" class="mo_img" alt="소비자피해보상보험 가입사실확인"> <img src="../../static/images/w_footer_hidden_info_logo_05.png" class="pc_img" alt="소비자피해보상보험 가입사실확인"> <span>소비자피해<br>보상보험<br>가입사실확인</span> </a> -->
                <span class="box_mark"><img src="../../static/images/m_footer_hidden_info_logo_06.png" class="mo_img" alt="소프트웨어 산업보호대상 장관상"><img src="../../static/images/w_footer_hidden_info_logo_06.png" class="pc_img" alt="소프트웨어 산업보호대상 장관상"><span>소프트웨어<br>산업보호대상<br>장관상</span></span>
                <span class="box_mark"><img src="../../static/images/m_footer_hidden_info_logo_07.png" class="mo_img" alt="소프트웨어 자산관리 인증"><img src="../../static/images/w_footer_hidden_info_logo_07.png" class="pc_img" alt="소프트웨어 자산관리 인증"><span>소프트웨어<br>자산관리<br>인증</span></span>
                <a href="https://www.macco.or.kr/ko/cn/KOCNMC01.action" target="_blank" title="새창열림" class="mac-co"> <img src="../../static/images/m_footer_hidden_info_logo_05_v2.png" class="mo_img" alt="소비자피해보상보험 가입사실확인"> <img src="../../static/images/w_footer_hidden_info_logo_05.png" class="pc_img" alt="소비자피해보상보험 가입사실확인"> <span>소비자피해 보상보험<br>가입사실확인</span> </a>
              </div>
              <!-- E : 20230714 하이브리스 footer 와 동일하게 현행화 -->
            </div>
            <div class="copyright-cont">
              <p>ALL CONTENTS Copyright ⓒ 2019 Amway Korea LTD.ALL RIGHTS RESERVED<img src="../../static/images/w_copyrights_logo_home.png" alt="amway"></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div
      id="ScrollTopArea"
      class="scrollTopWrapper"
    >
      <button
        type="button"
        class="toTop hidden-print"
        :style="computedTopBtnStyle"
        @click="onScrollTop"
      >
        TOP(위로이동)
      </button>
    </div>
  </div>
  <!-- E : footer -->
</template>

<script>

// eslint-disable-next-line no-unused-vars
import { mapGetters } from 'vuex';

function grabScrollEvent(evt) {
  if (window.pageYOffset > 0) {
    this.topButtonOpacity = 1;
  } else {
    this.topButtonOpacity = 0;
  }
}

export default {
  name: 'AppFooter',
  data() {
    return {
      isFooterInfoVisible: false,
      topButtonOpacity: 0,
    };
  },
  computed: {
    ...mapGetters({
      floatingButtons: "floatingButtons",
    }),
    classFooterInfoVisible() {
      return this.isFooterInfoVisible ? ['open'] : [];
    },
    classFooterInfoBtnActive() {
      return this.isFooterInfoVisible ? ['active'] : [];
    },
    computedTopBtnStyle() {
      return `opacity: ${this.topButtonOpacity}`;
    },
  },
  created() {
    window.addEventListener('scroll', grabScrollEvent.bind(this));
  },
  methods: {
    toggleBusinessInfo() {
      this.isFooterInfoVisible = !this.isFooterInfoVisible
    },
    onScrollTop() {
      document.getElementById('app').scrollIntoView({
        behavior: 'smooth',
      });
    },
    onScrollBottom() {
      this.isFooterInfoVisible = !this.isFooterInfoVisible;
      if (this.isFooterInfoVisible) {
        setTimeout(() => {
          document.getElementById('footer').scrollIntoView({
            behavior: 'smooth',
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.scrollTopWrapper button {
  transition: opacity 0.5s;
}
@media print {
  .hidden-print {
    display: none !important;
  }
}
</style>
